import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { push, replace } from "connected-react-router";
import { updateDisplayHtmlTag } from "reducers/ConceptDetails";
import { loadCreative } from "reducers/CreativeDetails";
import { loadCreatives } from "reducers/Creatives";
import {
	Modal,
	ReduxControls,
	Button,
	Layout,
	ProgressIndicator,
	ErrorBanner
} from "rhombus-react";

import "./EditCreativeTagModal.css";

export default function EditCreativeTagModal(props) {
	const {
		returnPath,
		creativeId,
		libraryId,
	} = props;

	const dispatch = useDispatch()
		, {
			isLoaded,
			isSaving,
			errorMessages,
			hasErrorLoading,
			name,
		} = useSelector((state) => {
			const { isSaving=false, errors={} } = state.conceptDetails || {}
				, { isLoaded=false, hasErrorLoading=false, name="" } = state.creativeDetails || {}
				, errorMessages = [];

			if(Object.keys(errors).length > 0){
				errorMessages.push(errors.description);
			}

			if(hasErrorLoading) {
				errorMessages.push("Error Loading Creative.");
			}

			return {
				isLoaded,
				isSaving,
				errorMessages,
				hasErrorLoading,
				name,
			};
		})
		, [displayHtmlTagCode, setDisplayHtmlTagCode] = useState('')
		, [isEdited, setIsEdited] = useState(false);

	useEffect(() => {
		dispatch(loadCreative(creativeId)).then((resp) => {
			if(resp?.success) {
				const { displayHtmlTagCode="" } = resp?.payload?.data || {};
				setDisplayHtmlTagCode(displayHtmlTagCode);
			}
		});
	}, [creativeId]);

	function saveCreativeTag() {
		dispatch(updateDisplayHtmlTag(libraryId, creativeId, { displayHtmlTagCode })).then((resp) => {
			if(resp?.success) {
				dispatch(loadCreatives(libraryId));
				dispatch(replace(returnPath));
			}
		});
	}

	function renderContent() {
		return (
			<div className="progress-container">
				<ProgressIndicator isOpaque={true} isLoading={!isLoaded || isSaving} />
				<ErrorBanner
					shouldDisplay={errorMessages.length > 0}
					title="Sorry, please fix the errors below and try again."
					messages={errorMessages}
				/>
				<ReduxControls.Input
					type="textarea"
					value={displayHtmlTagCode}
					disabled={hasErrorLoading}
					onChange={(value) => {
						setIsEdited(true);
						setDisplayHtmlTagCode(value);
					}}
				/>
			</div>
		);
	}

	function renderFooter() {
		return (
			<Layout.ModalFooter>
				<Button
					theme="default"
					disabled={isSaving}
					onClick={onClose}
				>Cancel</Button>
				<Button
					key="submit"
					type="submit"
					theme="green"
					onClick={saveCreativeTag}
					disabled={!displayHtmlTagCode || !isLoaded || isSaving || !isEdited || hasErrorLoading}
				>Save Creative Tag</Button>
			</Layout.ModalFooter>
		);
	}

	function onClose() {
		dispatch(push(returnPath));
	}

	let modalProps = {
		title: `Edit Creative Tag - ${name}`,
		setAppTitle: false,
		type: "modal",
		className: "edit-creative-tag-modal",

		xClose: true,
		allowFullScreen: false,
		bladeProps: {
			verticallyCenter: true,
		},

		renderContent,
		renderFooter,
		onClose,
	};

	return <Modal {...modalProps} />;
}
